
import { Users } from 'lucide-react';

const NoSubscriptionsMessage = () => {
  return (
    <div className="text-center py-16 bg-white dark:bg-youtube-dark shadow-sm rounded-lg border border-gray-200 dark:border-gray-800 animate-fade-in">
      <div className="mx-auto w-20 h-20 flex items-center justify-center bg-gray-100 dark:bg-gray-800 rounded-full mb-4">
        <Users className="w-10 h-10 text-youtube-red" />
      </div>
      <h2 className="text-xl font-medium mb-4">Aucun abonnement</h2>
      <p className="text-gray-500 dark:text-gray-400 mb-6 max-w-md mx-auto">
        Vous n'êtes abonné à aucun créateur pour le moment. Visitez la page Créateurs pour découvrir et vous abonner à vos créateurs favoris.
      </p>
      <a 
        href="/creators" 
        className="inline-flex items-center bg-youtube-red hover:bg-red-600 text-white px-6 py-2 rounded-full transition-all duration-300 transform hover:scale-105 active:scale-95"
      >
        Explorer les créateurs
      </a>
    </div>
  );
};

export default NoSubscriptionsMessage;
